import { Component } from 'react';
import { MapPin } from 'lucide-react';

export class MapErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Silently log — Maps failure should not break the surrounding page
    // eslint-disable-next-line no-console
    console.warn('Map failed to render:', error?.message || error);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="w-full h-full flex flex-col items-center justify-center bg-gray-100 text-muted p-8" data-testid="map-fallback">
            <MapPin className="w-8 h-8 mb-2 opacity-40" strokeWidth={1.5} />
            <div className="caps text-[10px] text-center">Map preview unavailable</div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default MapErrorBoundary;
